import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.css'],
})
export class IconButtonComponent {
  @Output() click = new EventEmitter<void>();
  @Input() width: String = '56px';
  @Input() height: String = '50px';
  @Input() margin: string = '0';
  @Input() styles: string | object;

  onClick(event: KeyboardEvent) {
    this.click.emit();
  }
}
